import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, message, Row, Col, Select } from 'antd';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import api from '../../../services/api';
import * as ModalStatusAction from '../../../redux/actions/modalStatus'

interface ModalNovoVinculoOrgaoServicoProps {
    modalStatus?: any,
    setNovoVinculoOrgaoServicoModal?: any,
}

const ModalNovoVinculoOrgaoServico: React.FC<ModalNovoVinculoOrgaoServicoProps> = (prop) => {

    let visible = prop.modalStatus[0].visibleNovoVinculoOrgaoServico
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;
    let orgaos: any[] = [];
    const [orgaosInput, setOrgaosInput] = useState<any[]>();
    let servicos: any[] = [];
    const [servicosInput, setServicosInput] = useState<any[]>();

    useEffect(() => {
        carregarDropdown();
        form.resetFields();
    }, [visible])

    const carregarDropdown = async () => {
        api.get(`Orgao/getall`).then((response) => {
            orgaos = response.data;
            setOrgaosInput(orgaos)
        })
        api.get(`Servico/getall`).then((response) => {
            servicos = response.data;
            setServicosInput(servicos)
        })
    }

    const handleCancel = () => {
        prop.setNovoVinculoOrgaoServicoModal(false)
    };

    const onFinish = (values: any) => {
        setLoading(true);
        api.post(`VinculoOrgaoServico`, {
            vinculoOrgaoServicoID: 0,
            orgaoID: values.orgao,
            servicoID: values.servico,
            Ativo: values.ativo == null ? null : values.ativo === "true" ? true : false,
        })
            .then((response) => {
                if (response.data.valido) {
                    message.success('Vínculo salvo com sucesso')
                    prop.setNovoVinculoOrgaoServicoModal(false);
                }
                else {
                    message.error(response.data.error)
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            })

    };

    return (
        <Modal
            visible={visible}
            title="Novo Vínculo Orgão Serviço"
            onCancel={handleCancel}
            footer={null}
        >
            <Form
                name="basic"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Orgão"
                            name="orgao"
                        >
                            <Select placeholder="Orgão">
                                {orgaosInput?.map(orgao => (
                                    <Option value={orgao.orgaoID}>{orgao.nome}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Serviço"
                            name="servico"
                        >
                            <Select placeholder="Serviço">
                                {servicosInput?.map(servico => (
                                    <Option value={servico.servicoID}>{servico.descricao}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Ativo"
                            name="ativo"
                            initialValue={null}
                        >
                            <Select placeholder="Ativo">
                                <Option value="null">Selecione</Option>
                                <Option value="true">Sim</Option>
                                <Option value="false">Não</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button className="button-pre-cadastro" type="primary" htmlType="submit">
                        Finalizar
                    </Button>
                </Form.Item>
            </Form>
        </Modal >
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(ModalStatusAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(ModalNovoVinculoOrgaoServico);